import { TableJSON } from './data-loader';

export type DemoDatasetID = 
  | 'titanic' 
  | 'iris' 
  | 'mtcars' 
  | 'house-price' 
  | 'weather'
  | 'flights-1m';

export interface DemoDataset {
  id: DemoDatasetID;
  name: string;
  description: string;
  rows: number;
  url: string;
  format: 'parquet';
}

export const demoDatasets: Record<DemoDatasetID, DemoDataset> = {
  'titanic': {
    id: 'titanic',
    name: 'Titanic Passengers',
    description: 'Information about Titanic passengers including survival status',
    rows: 891,
    url: '/sample-datasets/titanic.parquet',
    format: 'parquet'
  },
  'iris': {
    id: 'iris',
    name: 'Iris Flower Dataset',
    description: 'Classic dataset of iris flower measurements',
    rows: 150,
    url: '/sample-datasets/iris.parquet',
    format: 'parquet'
  },
  'mtcars': {
    id: 'mtcars',
    name: 'Motor Trend Car Road Tests',
    description: 'Fuel consumption and performance metrics for various car models',
    rows: 32,
    url: '/sample-datasets/mtcars.parquet',
    format: 'parquet'
  },
  'house-price': {
    id: 'house-price',
    name: 'House Prices',
    description: 'Housing prices with various features and attributes',
    rows: 1460,
    url: '/sample-datasets/house-price.parquet',
    format: 'parquet'
  },
  'weather': {
    id: 'weather',
    name: 'Weather Data',
    description: 'Historical weather measurements from various stations',
    rows: 2922,
    url: '/sample-datasets/weather.parquet',
    format: 'parquet'
  },
  'flights-1m': {
    id: 'flights-1m',
    name: 'Flight Data (1M rows)',
    description: 'Large dataset of flight information including delays and cancellations',
    rows: 1000000,
    url: '/sample-datasets/flights-1m.parquet',
    format: 'parquet'
  }
};

/**
 * Returns all demo datasets
 */
export function getAllDemoDatasets(): DemoDataset[] {
  return Object.values(demoDatasets);
}

/**
 * Returns a demo dataset by ID
 */
export function getDemoDataset(id: DemoDatasetID): DemoDataset | undefined {
  return demoDatasets[id];
}

/**
 * Returns demo datasets filtered by format
 */
export function getDemoDatasetsByFormat(format: string): DemoDataset[] {
  return Object.values(demoDatasets).filter(dataset => dataset.format === format);
} 